(function(){
  if(window.__tjjmCore)return;window.__tjjmCore=1;
  var rm=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(){
    var els=document.querySelectorAll('.tjjm-reveal:not(.tjjm-in)');
    if(rm){els.forEach(function(e){e.classList.add('tjjm-in')});return}
    var io=new IntersectionObserver(function(es){
      es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('tjjm-in');io.unobserve(en.target)}})
    },{threshold:.12});
    els.forEach(function(e){io.observe(e)});
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();
